module.exports = __webpack_public_path__ + "img/Day6_upsidedown_final.eec725e7.jpg";